<template>
<li class="flex wrap align-center space-between">
	<template v-if="skipStepNav">
		<Button class="text-only icon-last width-100 space-between" v-if="!isCurrentStep" :text="`Go to: ${item.name}`" @btnClick="$emit('confirm', item.pathName);">
			<template #icon>
				<arrow-right-icon classes="minr-icon_sml" />
			</template>
		</Button>
		<template v-else>
			<span>{{ item.name }}</span>
			<span class="status info">You are here</span>
		</template>
	</template>

	<template v-else>
		<div class="flex align-center">
			<span>{{ item.name }}</span>
		</div>
	</template>
</li>
</template>

<script>

export default {
	name: 'StepStatusItem',
	props: {
		item: {
			type: Object,
			default () {
				return {};
			}
		},
		skipStepNav: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		isCurrentStep () {
			return this.$route.name === this.item.pathName;
		}

	}

};

</script>
